const PhotoSection = ({userData}) => {



    return (
                  <div className="flex h-[250px] gap-4 max-w-full mb-7 mx-auto px-2 w-full justify-center">
            {/* Первая фотография с лейблом */}
            <div className="relative w-1/2 max-w-[200px] min-w-[140px] aspect-[4/5]">
              <img
                src={localStorage.getItem("photo")}
                alt="User"
                className="w-full h-full object-cover rounded-xl bg-white transition-all duration-300"
              />
              <span className="absolute bottom-2 left-2 bg-white text-gray-700 text-xs font-semibold px-2 py-0.5 rounded-full shadow">
                Day 0
              </span>
            </div>

            {/* Вторая фотография с лейблом */}
            <div className="relative w-1/2 max-w-[200px] min-w-[140px] aspect-[4/5]">
              <svg style={{ display: "none" }}>
                <filter id="sharpness">
                  <feConvolveMatrix
                    order="3"
                    kernelMatrix="0 -0.5 0 -0.5 3 -0.5 0 -0.5 0"
                    divisor="1"
                  />
                </filter>
              </svg>

              <img
                src={localStorage.getItem("photo")}
                alt="User"
                className="w-full h-full object-cover rounded-xl bg-white transition-all duration-300"
                style={{
                  filter:
                    "brightness(1.03) contrast(1.05) saturate(1.05) sepia(0.01) url(#sharpness)",
                }}
              />
              <span className="absolute bottom-2 left-2 bg-pink-100 text-pink-600 text-xs font-semibold px-2 py-0.5 rounded-full shadow">
                Your goal
              </span>
            </div>
          </div>
    )
}


export default PhotoSection;